import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import {SupportTicketStatusEnum} from '../../../../model/support/support-ticket-status.enum';
import {SupportTicketModel} from '../../../../model/support/support-ticket.model';
import {SupportTicketUtils} from '../utils/support-ticket.utils';
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person'

type Props = {
  ticket: SupportTicketModel
  translate: (key: string) => string
}

export const SupportTicketRelatedTasksDrawerHeader = ({ticket, translate}: Props) => {
  const translateStatus = (status: SupportTicketStatusEnum) => translate(`support.ticket.status.${status}`)
  const buildStatus = (status: SupportTicketStatusEnum) => {
    const Icon = SupportTicketUtils.getStatusIcon(status)

    return <Box display="flex" alignItems="center" gap={1}>
      <Icon style={{ color: SupportTicketUtils.getStatusIconColor(status) }} />
      {translateStatus(status)}
    </Box>
  }

  return <Box
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    fontSize="0.85rem"
  >
    <Typography variant="body2">
      Zgłoszenie:{" "}
      <Typography component="span" variant="body2" fontWeight="600">
        {ticket.id}
      </Typography>
    </Typography>
    <Box display="flex" alignItems="center" gap={2}>
      <Box display="flex" alignItems="center" gap={0.5}>
        <GroupIcon fontSize="small" sx={{ color: "#1E3A8A" }} />
        <Typography variant="body2">{ticket.organizationName}</Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={0.5}>
        <PersonIcon fontSize="small" sx={{ color: "#1E3A8A" }} />
        <Typography variant="body2">{ticket.accountName}</Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={0.5}>
        {buildStatus(ticket.status)}
      </Box>
    </Box>
  </Box>
}